const config = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || "",
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || "",
      loginWith: {
        email: true,
      },
    },
  },
};

// Check for missing environment variables
if (!process.env.REACT_APP_USER_POOL_ID) {
  console.error("Missing environment variable: REACT_APP_USER_POOL_ID");
}

if (!process.env.REACT_APP_USER_POOL_CLIENT_ID) {
  console.error("Missing environment variable: REACT_APP_USER_POOL_CLIENT_ID");
}

export default config;
